export default __webpack_public_path__ + "static/media/PYLE.7cac8dae.png";